const callerKey = (agentId: string) => `scenario-test-caller:${agentId}`;
const nowKey = (agentId: string) => `scenario-test-now:${agentId}`;

const read = (key: string): string => {
  try {
    return localStorage.getItem(key) ?? '';
  } catch {
    return '';
  }
};

const write = (key: string, value: string): void => {
  try {
    if (value) {
      localStorage.setItem(key, value);
    } else {
      localStorage.removeItem(key);
    }
  } catch {
    // Storage may be unavailable (private mode); the test values are optional.
  }
};

export const getScenarioTestCallerNumber = (agentId: string): string => read(callerKey(agentId));

export const setScenarioTestCallerNumber = (agentId: string, value: string): void =>
  write(callerKey(agentId), value);

/** Test time for web test calls, local to the organization, e.g. "2026-11-02T16:30"; empty means real time. */
export const getScenarioTestNow = (agentId: string): string => read(nowKey(agentId));

export const setScenarioTestNow = (agentId: string, value: string): void => write(nowKey(agentId), value);

/** Body of POST /agents/agents/{id}/test-session/ with the stored test values; undefined without any. */
export const scenarioTestSessionBody = (agentId: string): { caller_number?: string; now?: string } | undefined => {
  const callerNumber = getScenarioTestCallerNumber(agentId);
  const now = getScenarioTestNow(agentId);
  if (!callerNumber && !now) return undefined;
  return { ...(callerNumber ? { caller_number: callerNumber } : {}), ...(now ? { now } : {}) };
};
